import axios from 'axios'
import * as querystring from 'querystring'

import  config  from '../config/urlConfig'
import formatAxiosError from '../util/formatAxiosError'

export default class {
  static dangKy(values) {
    return axios
      .post(`${config.app.api}/api/khachhang/dang-ky`, values)
      .then(response => {
        return null
      })
      .catch(error => {
        let formatedError = formatAxiosError(error)
        throw formatedError
      })
  }
}
